import React from 'react';
import { Card } from './Card';
import { TrendingUp, TrendingDown } from 'lucide-react';
interface KPICardProps {
  title: string;
  value: string | number;
  change?: string;
  trend?: 'up' | 'down';
  subtext?: string;
  icon?: React.ReactNode;
  variant?: 'default' | 'positive' | 'neutral' | 'negative';
}
export function KPICard({
  title,
  value,
  change,
  trend,
  subtext,
  icon,
  variant = 'default'
}: KPICardProps) {
  const variantStyles = {
    default: {
      bg: '',
      iconColor: 'text-edeka-blue opacity-80',
      titleColor: 'text-gray-500',
      valueColor: 'text-gray-900'
    },
    positive: {
      bg: 'bg-[#e8f5e4] border-[#639754]/20',
      iconColor: 'text-[#639754]',
      titleColor: 'text-[#4a7340]',
      valueColor: 'text-[#2d5a1e]'
    },
    neutral: {
      bg: 'bg-[#fffbeb] border-[#FFD301]/30',
      iconColor: 'text-[#b39500]',
      titleColor: 'text-[#8a7300]',
      valueColor: 'text-[#6b5900]'
    },
    negative: {
      bg: 'bg-[#fef2f2] border-[#E03C32]/20',
      iconColor: 'text-[#E03C32]',
      titleColor: 'text-[#b32d25]',
      valueColor: 'text-[#8b1a13]'
    }
  };
  const styles = variantStyles[variant];
  return <Card className={`flex flex-col h-full justify-between transition-shadow duration-200 ${styles.bg}`} data-id="element-164">
      <div className="flex justify-between items-start mb-2" data-id="element-165">
        <span className={`text-sm font-medium ${styles.titleColor}`} data-id="element-166">
          {title}
        </span>
        {icon && <div className={styles.iconColor} data-id="element-167">{icon}</div>}
      </div>

      <div className="flex items-end gap-3 mt-1" data-id="element-168">
        <h3 className={`text-4xl font-bold ${styles.valueColor}`} data-id="element-169">{value}</h3>
        {change && trend && <div className={`flex items-center gap-1 text-xs font-semibold pb-1 ${trend === 'up' ? 'text-[#639754]' : 'text-[#E03C32]'}`} data-id="element-170">
            {trend === 'up' ? <TrendingUp size={13} data-id="element-171" /> : <TrendingDown size={13} data-id="element-172" />}
            <span data-id="element-173">{change}</span>
          </div>}
      </div>

      {subtext && <span className={`text-xs mt-1 ${styles.titleColor} opacity-70`} data-id="element-174">
          {subtext}
        </span>}
    </Card>;
}